import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from "src/app/data.service";
import { ToastService } from "ng-uikit-pro-standard";

export interface Domain {
  id: number;
  name: string;
  label: string;
  description: string;
  active: boolean;
}

@Component({
  selector: "app-domain-settings",
  templateUrl: "./domain-settings.component.html",
  styleUrls: ["./domain-settings.component.scss"],
})
export class DomainSettingslistComponent implements OnInit {
  isLoading = false;
  isError = false;
  domainsettings: any;
  errorMessage = "";
  displayedColumns: string[] = [
    "action",
    "domainkey",
    "label",
    "description",
    "active",
  ];
  dataSource: "";

  constructor(
    private router: Router,
    private dataService: DataService,
    private toastrService: ToastService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getDomainSetting();
    const domainKey = this.route.snapshot.paramMap.get("domainkey");
    // console.log("Domain Key:", domainkey);
  }

  cancel() {
    this.router.navigateByUrl("/home");
  }

  new() {
    this.router.navigateByUrl("/home/domainsettinglist/new");
  }

  editApp(element: any) {
    this.router.navigateByUrl("/home/domainsettinglist/edit/" + element.id);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  delete(id: any, type: any) {
    // alert(id)
    // const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService.deleteDomainSetting(id, type, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")

          this.showSuccess(res.message);
          this.isLoading = false;

          // window.location.reload();
          this.getDomainSetting();
        } else {
          console.log("Failed to delete!");
          this.isLoading = false;
          this.showError(res.message);
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.showError(err.message);
      }
    );
  }

  //   goToDomainSection(domainkey: string) {
  //   this.router.navigateByUrl(`/home/domainsection/${domainkey}`);
  // }

  // goToDomainSection(domainkey: string, element: any) {
  //   this.router.navigateByUrl(`/home/domainsectionlist/${domainkey}/` + element.id);
  // }

  goToDomainSection(domainkey: string, element: any) {
    this.router.navigateByUrl(
      `/home/domainsectionlist/${domainkey}/` + element.id
    );
  }

  // goToDomainSection( ) {
  //   this.router.navigateByUrl(`/home/domainsection`);
  // }

  getDomainSetting() {
    return new Promise((resolve, reject) => {
      console.log("getDomainSetting");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      console.log("org id", organizationid);
      console.log("domain", domain);
      console.log("subdomain", subdomain);
      this.isLoading = true;
      this.dataService
        .getAllDomainSetting(domain, subdomain, organizationid)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.domainsettings = res.data.domainsetting;
              console.log("Doneeee****", this.domainsettings);

              if (this.domainsettings != null) {
                this.dataSource = this.domainsettings.map((domainsetting) => ({
                  id: domainsetting.id,
                  // domainkey: domainsetting.domainkey,
                  name: domainsetting.name,
                  label: domainsetting.label,
                  description: domainsetting.description,
                  active: domainsetting.active,
                  // modifieddate: convertsetting.modifieddate,
                  // createdby: convertsetting.createdby,
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }
}
